const DEVICE_ID_KEY = 'odoo-dashboard:intercom-device-id';
const TV_MODE_KEY = 'odoo-dashboard:intercom-tv-mode';
const TV_MODE_EVENT = 'intercom:tv-mode-changed';

let fallbackDeviceId;

export function getIntercomDeviceId() {
  try {
    const existing = window.localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;
    const generated = window.crypto?.randomUUID?.() || `device-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(DEVICE_ID_KEY, generated);
    return generated;
  } catch (error) {
    fallbackDeviceId ||= `device-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    return fallbackDeviceId;
  }
}

export function isIntercomTvDashboard() {
  try {
    return window.localStorage.getItem(TV_MODE_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

export function setIntercomTvDashboard(enabled) {
  const isTv = Boolean(enabled);
  try {
    window.localStorage.setItem(TV_MODE_KEY, String(isTv));
  } catch (error) {
    // Le mode reste utilisable pour l'onglet courant même sans stockage persistant.
  }
  window.dispatchEvent(new CustomEvent(TV_MODE_EVENT, { detail: { isTv } }));
  return isTv;
}

export function subscribeToIntercomTvMode(callback) {
  const handleCustomEvent = event => callback(event.detail?.isTv === true);
  const handleStorage = event => {
    if (event.key === TV_MODE_KEY) callback(event.newValue === 'true');
  };
  window.addEventListener(TV_MODE_EVENT, handleCustomEvent);
  window.addEventListener('storage', handleStorage);
  return () => {
    window.removeEventListener(TV_MODE_EVENT, handleCustomEvent);
    window.removeEventListener('storage', handleStorage);
  };
}

export { DEVICE_ID_KEY, TV_MODE_KEY };
